module.exports = __webpack_public_path__ + "static/media/pinball.b70d275d.png";